import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Session, {
  ALL_SUMMARY_PARAMS,
  IS_VALIDATE,
} from '../../common/services/Session';
import { buysideRequested } from '../../common/utils/constants/ErrorCodes';
import { stopLog } from '../../common/utils/logger';
import { isEmpty } from '../../common/utils/shared';
import {
  getBuysideDataAction,
  getRateSelectorAction,
  getSettingAction,
  getValidateDataAction,
} from '../../data/lockSummary/actionCreators';
import {
  StyledEppsContainerBody,
  StyledEppsParentView,
  StyledEppsWrapper,
} from '../global/styles/styled';
import { CompareRates } from './components/CompareRates';
import { FooterActionButtons } from './components/FooterActionButtons';
import { LockConfirm } from './components/LockConfirm';

export const LockConfirmWrapper = () => {
  const dispatch = useDispatch();
  const [isCompareRatesView, setIsCompareRatesView] = useState(false);
  const isValidate = Session.get(IS_VALIDATE);
  const { current: userWentToSearchResult } = useRef(
    !isEmpty(Session.get(ALL_SUMMARY_PARAMS)),
  );
  const initData = async () => {
    if (!userWentToSearchResult) {
      // TODO(ngen): these methods were awaited, but they didn't return a promise (on the outside of dispatch)
      dispatch(getSettingAction() as any);
      if (isValidate) {
        dispatch(getValidateDataAction() as any);
      }
      if (!isValidate) {
        dispatch(getBuysideDataAction() as any);
      }
    }
    if (userWentToSearchResult) {
      dispatch(getRateSelectorAction() as any);
    }
  };

  useEffect(() => {
    initData();
    stopLog(buysideRequested);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isCompareRatesView && (
        <CompareRates handleBack={() => setIsCompareRatesView(false)} />
      )}
      {!isCompareRatesView && (
        <StyledEppsParentView>
          <StyledEppsContainerBody>
            <StyledEppsWrapper>
              <LockConfirm setIsCompareRatesView={setIsCompareRatesView} />
            </StyledEppsWrapper>
          </StyledEppsContainerBody>
          <FooterActionButtons />
        </StyledEppsParentView>
      )}
    </>
  );
};
